interface SetParamsFilters {
  limit?: number;
  offset?: number;
  search?: string | string[];
  filters?: { [key: string]: string[] };
}

const setParams = (filters: SetParamsFilters): Record<string, unknown> => {
  let params: Record<string, unknown> = { limit: 2000, offset: 0 };
  if (filters.limit) params = { ...params, limit: filters.limit };
  if (filters.offset) params = { ...params, offset: filters.offset };
  const searchFilters = Array.isArray(filters.search)
    ? filters.search
    : (filters.search as string).trim().split(' ');
  // if (filters.search) {
  //   const searchFilters = filters.search.trim().split(' ');
  //   params = { ...params, 'filters[search]': searchFilters };
  // }
  params = { ...params, 'filters[search]': searchFilters };
  if (filters.filters && Object.keys(filters.filters).length > 0) {
    for (const [key, value] of Object.entries(filters.filters)) {
      params = { ...params, [`filters[${key}]`]: value };
    }
  }
  return params;
};

export default setParams;
